module.exports = __webpack_public_path__ + "assets/fe153024bf6461a664145c1ce8501744.svg";